import { StepStatusEnum } from '@lib/enums/step-status.enum';
import { FileMetadata } from './generated/graphql';

export class FileDocument {
  fileName: string;
  documentType: string;
  updatedDate: Date;
  url?: string;
  description?: string;
  fileId?: string | null;
  investisseurIds?: number[];
  file?: File;
  isFakeFile?: boolean;
  isPendingGeneration?: boolean;
  generationKey?: string;
  fromDocumentMinotaure?: boolean;
  stepStatus?: StepStatusEnum;
  dateReference?: Date;
  disabledInvestisseurId?: number;
  disabledIfSigned: boolean = true;

  constructor(
    fileName: string,
    updatedDate: Date,
    documentType: string,
    url?: string,
    description?: string,
    fileId?: string,
    investisseurIds?: number[],
    file?: File
  ) {
    this.fileName = fileName;
    this.url = url;
    this.updatedDate = updatedDate;
    this.documentType = documentType;
    this.description = description;
    this.fileId = fileId ? fileId.split('#')[0] : null;
    this.investisseurIds = investisseurIds;
    this.file = file;
  }

  static fromFileMetadata(fileMetadata: FileMetadata, description?: string): FileDocument {
    return new FileDocument(
      fileMetadata.fileName as string,
      fileMetadata.dateDeDerniereModification,
      fileMetadata.typeDocumentCode as string,
      fileMetadata.url as string,
      description,
      fileMetadata.fileId as string,
      fileMetadata.investisseurIds ?? []
    );
  }
}
